<header>
    <div class="top-header flex justify-center align-center w-100">
        <div class="top-header-reseaux flex justify-right align-center">
            <a href="https://www.facebook.com/JordanKrsticCoaching" target="_blank">
                <i class="bi bi-facebook"></i>
            </a>
            <a href="https://www.instagram.com/heat.training/" target="_blank">
                <i class="bi bi-instagram"></i>
            </a>
        </div>
        <div class="top-address d-none d-sm-block">
            <a class="flex"
               href="https://goo.gl/maps/zVtBmTT2rEXjGHef9" target="_blank">
                <i class="bi bi-geo-alt-fill"></i>
                <div class="margin-0">3 place des martinets 13670 Saint Andiol</div>
            </a>
        </div>
        <div class="top-tel flex justify-right align-center">
            <i class="bi bi-phone-fill"></i>
            <div class="margin-0">06 16 34 66 96</div>
        </div>
    </div>
    <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
            <a class="navbar-brand" href="#">
                <img src="./assets/img/logo-zoom.png" alt="logo Heat Sport">
            </a>
            <button class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNavAltMarkup"
                    aria-controls="navbarNavAltMarkup"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                <i class="bi bi-list"></i>
            </button>
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div *ngFor="let link of links" class="navbar-nav">
                    <a class="nav-link"
                       routerLink="{{ link.url }}"
                       routerLinkActive="active"
                       aria-current="page">
                        {{ link.text }}
                    </a>
                </div>
            </div>
        </div>
    </nav>
</header>
